// src/data/skillTaxonomy.js

export const ENGLISH_SKILLS = [
  "lwc", "muc", "ap",
  "os", "fsp", "lp",
  "mpp", "agi", "mpt",
  "a", "d", "r", "c",
  "mi", "cd", "ds",
  "qbs", "sle",
  "dc", "ds_q", "dt", "cbg",
  "ti", "fah", "lc", "mr",
  "pc", "cc", "rf",
  "vtf", "sva", "pa", "mmp", "wfp", "pm",
  "ce", "cc_t", "ar", "es", "st", "cr",
  "em", "pi", "ex", "sg", "s", "cc_r", "uqe",
];

export const MATH_SKILLS = [
  "sle", "eeq", "svc", "sfe",
  "wec", "eop",
  "sc", "si", "yic", "yii", "wet", "weg",
  "ssa", "ssg", "sfc", "nos", "nsc", "isc",
  "sineq", "mcc", "tvt",
  "fac", "exp", "er", "res", "sfi",
  "qe", "ave", "xeq", "nos_nl",
  "lqs", "nss",
  "vi", "mmv", "ft", "egd", "dht",
  "uc", "ur", "pr", "sf",
  "poq", "pid", "mean", "med",
  "sp", "lbf", "sfd", "pfm",
  "simp", "pft",
  "evs", "sps",
  "cva", "voc",
  "area", "per", "vol", "se", "cf",
  "ar", "plt", "tsim", "tcon", "pt", "srt", "tr", "tir",
  "ec", "cri", "drr", "al", "arq", "ct", "if",
];

export const ENGLISH_SUBTOPICS = {
  wc: {
    name: "Words in Context",
    pillar: "cs",
    skills: ["lwc", "muc", "ap"],
  },
  ts: {
    name: "Text Structure",
    pillar: "cs",
    skills: ["os", "fsp", "lp"],
  },
  tp: {
    name: "Text Purpose",
    pillar: "cs",
    skills: ["mpp", "agi", "mpt"],
  },
  ctc: {
    name: "Cross-Text Connections",
    pillar: "cs",
    skills: ["a", "d", "r", "c"],
  },

  cid: {
    name: "Central Ideas and Details",
    pillar: "ii",
    skills: ["mi", "cd", "ds"],
  },
  tce: {
    name: "Textual Command of Evidence",
    pillar: "ii",
    skills: ["qbs", "sle"],
  },
  qce: {
    name: "Quantitative Command of Evidence",
    pillar: "ii",
    skills: ["dc", "ds_q", "dt", "cbg"],
  },
  i: {
    name: "Inferences",
    pillar: "ii",
    skills: ["ti", "fah", "lc", "mr"],
  },

  b: {
    name: "Boundaries",
    pillar: "sec",
    skills: ["pc", "cc", "rf"],
  },
  f: {
    name: "Form, Structure, and Sense",
    pillar: "sec",
    skills: ["vtf", "sva", "pa", "mmp", "wfp", "pm"],
  },

  t: {
    name: "Transitions",
    pillar: "ei",
    skills: ["ce", "cc_t", "ar", "es", "st", "cr"],
  },
  rs: {
    name: "Rhetorical Synthesis",
    pillar: "ei",
    skills: ["em", "pi", "ex", "sg", "s", "cc_r", "uqe"],
  },
};

export const MATH_SUBTOPICS = {
  "1vle": {
    name: "1 Variable Linear Equations",
    pillar: "alg",
    skills: ["sle", "eeq", "svc", "sfe"],
  },
  "2vle": {
    name: "2 Variable Linear Equations",
    pillar: "alg",
    skills: ["wec", "eop"],
    unlocks: ["1vle"],
  },
  lf: {
    name: "Linear Functions",
    pillar: "alg",
    skills: ["sc", "si", "yic", "yii", "wet", "weg"],
  },
  lse: {
    name: "Linear Systems of Equations",
    pillar: "alg",
    skills: ["ssa", "ssg", "sfc", "nos", "nsc", "isc"],
    unlocks: ["lf"],
  },
  li: {
    name: "Linear Inequalities",
    pillar: "alg",
    skills: ["sineq", "mcc", "tvt"],
  },

  ee: {
    name: "Equivalent Expressions",
    pillar: "am",
    skills: ["fac", "exp", "er", "res", "sfi"],
  },
  nse: {
    name: "Nonlinear Systems of Equations",
    pillar: "am",
    skills: ["lqs", "nss"],
    unlocks: ["1vne"],
  },
  "1vne": {
    name: "1 Variable Nonlinear Equations",
    pillar: "am",
    skills: ["qe", "ave", "xeq", "nos_nl"],
  },
  nf: {
    name: "Nonlinear Functions",
    pillar: "am",
    skills: ["vi", "mmv", "ft", "egd", "dht"],
  },

  rrru: {
    name: "Ratios, Rates, Proportional Relationships, and Units",
    pillar: "ps",
    skills: ["uc", "ur", "pr", "sf"],
  },
  "1vd": {
    name: "Percentages and 1 Variable Data",
    pillar: "ps",
    skills: ["poq", "pid", "mean", "med"],
  },
  "2vd": {
    name: "2 Variable Data",
    pillar: "ps",
    skills: ["sp", "lbf", "sfd", "pfm"],
    unlocks: ["1vd"],
  },
  prob: {
    name: "Probability",
    pillar: "ps",
    skills: ["simp", "pft"],
  },
  esc: {
    name: "Evaluating Statistical Claims",
    pillar: "ps",
    skills: ["cva", "voc"],
    unlocks: ["is"],
  },
  is: {
    name: "Inference from Statistics",
    pillar: "ps",
    skills: ["evs", "sps"],
  },

  av: {
    name: "Area and Volume",
    pillar: "gt",
    skills: ["area", "per", "vol", "se", "cf"],
  },
  latt: {
    name: "Lines, Angles, Triangles, and Trigonometry",
    pillar: "gt",
    skills: ["ar", "plt", "tsim", "tcon", "pt", "srt", "tr", "tir"],
  },
  c: {
    name: "Circles",
    pillar: "gt",
    skills: ["ec", "cri", "drr", "al", "arq", "ct", "if"],
  },
};

